import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  
  /**
   * Argentina timezone: America/Argentina/Buenos_Aires = UTC-3
   * No DST in Argentina
   */
  private readonly ARGENTINA_OFFSET_HOURS = -3;

  /**
   * Converts a UTC date to Argentina timezone (America/Argentina/Buenos_Aires)
   * and returns formatted string: DD/MM/YY HH:MM
   */
  formatToArgentinaDateTime(value: any): string {
    if (!value) {
      return '-';
    }

    try {
      // Parse the date - ensure it's treated as UTC
      const date = this.parseAsUTC(value);

      if (!date || Number.isNaN(date.getTime())) {
        return '-';
      }

      // Get UTC components
      const utcTime = date.getTime();
      const offsetMs = this.ARGENTINA_OFFSET_HOURS * 60 * 60 * 1000;
      const argentinaTime = new Date(utcTime + offsetMs);

      // Extract components from the offset-adjusted date
      const year = String(argentinaTime.getUTCFullYear()).slice(-2);
      const month = String(argentinaTime.getUTCMonth() + 1).padStart(2, '0');
      const day = String(argentinaTime.getUTCDate()).padStart(2, '0');
      const hours = String(argentinaTime.getUTCHours()).padStart(2, '0');
      const minutes = String(argentinaTime.getUTCMinutes()).padStart(2, '0');

      const formatted = `${day}/${month}/${year} ${hours}:${minutes}`;
      return formatted;
    } catch (error) {
      return '-';
    }
  }

  /**
   * Converts a UTC date to Argentina timezone and returns date-only string: DD/MM/YYYY
   */
  formatToArgentinaDateOnly(value: any): string {
    if (!value) {
      return '-';
    }

    try {
      // Parse the date - ensure it's treated as UTC
      const date = this.parseAsUTC(value);

      if (!date || Number.isNaN(date.getTime())) {
        return '-';
      }

      // Get UTC components
      const utcTime = date.getTime();
      const offsetMs = this.ARGENTINA_OFFSET_HOURS * 60 * 60 * 1000;
      const argentinaTime = new Date(utcTime + offsetMs);

      // Extract components from the offset-adjusted date
      const day = String(argentinaTime.getUTCDate()).padStart(2, '0');
      const month = String(argentinaTime.getUTCMonth() + 1).padStart(2, '0');
      const year = argentinaTime.getUTCFullYear();

      const formatted = `${day}/${month}/${year}`;
      return formatted;
    } catch (error) {
      return '-';
    }
  }

  /**
   * Parse a value as UTC date
   * If it's a string without 'Z', append 'Z' to mark as UTC
   */
  private parseAsUTC(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (typeof value === 'string') {
      // If string doesn't end with Z, append it to mark as UTC
      const dateStr = !value.endsWith('Z') && !value.endsWith('+00:00') ? `${value}Z` : value;
      return new Date(dateStr);
    } else if (value instanceof Date) {
      return value;
    } else {
      return new Date(value);
    }
  }
}
